import { Box } from "@mui/material"
import LandingBannerComponent from "./landing-banner.component"
import LandingCompetitiveAdvantageComponent from "./landing-competitive-advantage.component"
import LandingStrategicGoalsComponent from "./landing-strategic-goals.component"
import LandingCoreValuesComponent from "./landing-core-values.component"
import LandingProductsComponent from "./landing-products.componet"
import LandingPartnersComponent from "./landing-partners.component"

const LandingContentComponent = () => {

    return(

        <Box>
            <LandingBannerComponent />
            <LandingCompetitiveAdvantageComponent />
            <LandingStrategicGoalsComponent />
            <br/>
            <LandingCoreValuesComponent />
            <br/>
            <LandingProductsComponent />
            <br/>
            <LandingPartnersComponent />
        </Box>

    )
}

export default LandingContentComponent